import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ListItem, Typography } from '@sm/wds-react';

const titleClassname = classNames('sm-mobile-menu__type-title');

export const SubMenuLink = ({ subTitle, title, url, openInNewWindow }) => {
  return (
    <ListItem
      key={title}
      isNavigable
      navigationTarget={url}
      className="sm-mobile-menu__nested-item"
      {...(openInNewWindow === true && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
    >
      <Typography
        variant="sectionTitle"
        color="link"
        className={titleClassname}
      >
        {title}
      </Typography>
      <p className="sm-mobile-menu-anon__type-subtitle">{subTitle}</p>
    </ListItem>
  );
};

export default SubMenuLink;

SubMenuLink.propTypes = {
  subTitle: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  openInNewWindow: PropTypes.bool,
};

SubMenuLink.defaultProps = {
  subTitle: '',
  title: '',
  url: '',
  openInNewWindow: false,
};
